import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {EuroSign24} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

export const getFinancialMenu = ({enableRatesOverview = false}): MenuItemConfig => {
  return {
    type: 'parent',
    label: 'finance.index.financial',
    icon: markRaw(EuroSign24),
    children: [
      {
        type: 'internal',
        to: {
          name: 'invoices',
        },
        label: 'finance.invoice.title',
        multiplyLabel: true,
      },
      {
        type: 'internal',
        to: {
          name: 'invoice-upcoming',
        },
        label: 'finance.invoice.upcoming.title',
      },
      {
        type: 'internal',
        to: {
          name: 'credit-debit',
        },
        label: 'finance.exceptionalPayments.title',
      },
      {
        type: 'internal',
        to: {
          name: 'prices',
        },
        activeRouteNameAliases: ['prices-scale-postnl', 'prices-scale-dhl', 'prices-scale-dpd'],
        label: 'finance.rates.tariff',
        multiplyLabel: true,
        show: () => enableRatesOverview,
      },
    ],
  };
};
